module.exports = __webpack_public_path__ + "img/ynbs.40d5c70e.png";